import React from 'react';
import MedicalRecordStatusBadge from 'components/MedicalRecordStatusBadge/MedicalRecordStatusBadge';
import useDocumentPromotion from 'modules/FileManagerV2/hooks/api/useDocumentPromotion';
import PromotionLogPanel from './PromotionLogPanel';

/**
 * Renders promotion badge and audit log for the active preview file.
 * @param {{ item: object|null }} props
 */
const PreviewMedicalRecordSection = ({ item }) => {
  const fileId = item?.file_id || item?.object_id;
  const isFile = item && item.entry_type !== 'folder';

  const { promotionStatus, promotedAt, promotionSource, promotionLog } = useDocumentPromotion(fileId, {
    enabled: !!fileId && isFile,
  });

  if (!isFile || !fileId) {
    return null;
  }

  return (
    <div className="preview-medical-record-section px-3 py-2" data-testid="preview-medical-record-section">
      <div className="mb-2" data-testid="preview-medical-record-badge">
        <MedicalRecordStatusBadge status={promotionStatus} promotedAt={promotedAt} promotionSource={promotionSource} />
      </div>
      <PromotionLogPanel promotionLog={promotionLog} />
    </div>
  );
};

export default PreviewMedicalRecordSection;
